
import Vue from 'vue'
import store from '@/store'
import routes from '@/router/routes'
import { loginApi } from '@/api/auth/login'
import SwitchLocale from './SwitchLocale.vue'

export default Vue.extend({
  components: { SwitchLocale },
  name: 'ArqanaHeader',

  data: () => ({
    dialogLogout: false,
    authState: store.state,
    tab: null,
  }),
  methods: {
    accountInitials() : string {
      if (!this.fullname) {
        return ''
      } else {
        const name = this.fullname.split(' ')
        return `${name[0].charAt(0)}${name[1] ? name[1].charAt(0) : ''}`
      }
    },
    switchDialogLogout() {
      this.dialogLogout = !this.dialogLogout
    },
    logout() {
      store.logout()
      loginApi.logout()
      this.$router.push('/login')
      this.dialogLogout = false
    },
    isTrot(): boolean {
      return !!process.env.VUE_APP_IS_TROT
    },
  },
  computed: {
    isFr() {
      return this.$i18n.locale === 'fr'
    },
    activeItems() {
      return routes.filter(route => {
        if (typeof route.display === 'function') {
          return route.display()
        } else {
          // eslint-disable-next-line no-param-reassign
          route.text = this.$t(route.key as string) as string
          return route.display !== false
        }
      })
    },
    showHeader() {
      return this.$route.name !== 'Login'
              && this.$route.name !== 'Register'
              && !this.$route.name?.includes('Password')
              && this.$route.name !== 'trigger-activation'
              && this.$route.name !== 'account-activation'
    },
    fullname(): string | undefined {
      if (store.state.userInfo !== undefined) {
        return store.state.userInfo.fullname ?? store.state.userInfo.fullname
      }
      return undefined
    },
    modeNoProd() {
      if (process.env.VUE_APP_MODE === 'prod') {
        return ''
      } else {
        return process.env.VUE_APP_MODE?.toUpperCase()
      }
    },
  },
})
